import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Shield, Phone, LogIn, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/hola/PasswordInput";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { phone, password });
      localStorage.setItem("holaradar_admin_token", data.token);
      toast.success("Bienvenido " + (data.admin?.name || "Admin"));
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-white mb-8" data-testid="admin-back-home">
          <ArrowLeft className="w-4 h-4" /> Regresar
        </Link>
        <div className="text-center mb-8">
          <div className="inline-flex w-14 h-14 rounded-2xl bg-[#FF007A] grid place-items-center mb-4">
            <Shield className="w-7 h-7 text-white" />
          </div>
          <h1 className="font-heading text-3xl font-extrabold">Acceso Admin</h1>
          <p className="text-sm text-neutral-400 mt-2">Sólo personal autorizado de HOLA RADAR.</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-neutral-300">Celular</Label>
            <div className="mt-1.5 relative">
              <Phone className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
              <Input
                data-testid="admin-phone-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="3342802102"
                className="pl-9 h-11 rounded-xl bg-white/5 border-white/10 text-white placeholder:text-neutral-500 focus:border-[#FF007A]"
                required
              />
            </div>
          </div>
          <div>
            <Label className="text-neutral-300">Contraseña</Label>
            <PasswordInput
              testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1.5 h-11 rounded-xl bg-white/5 border-white/10 text-white placeholder:text-neutral-500 focus:border-[#FF007A]"
              required
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full h-12 rounded-full bg-[#FF007A] hover:bg-[#e5006e] font-bold"
          >
            <LogIn className="w-4 h-4" /> {loading ? "Entrando..." : "Entrar al panel"}
          </Button>
        </form>
      </div>
    </div>
  );
}
